import React from "react";
import {Button, Price} from "../../index";

import "./product.css";

const ProductCard = (product) => {
  const { id, img, name, price, style, onClickAddProduct, addedCount } = product;

  const onAddProduct = () => {
    const obj = {
      id,
      name,
      img,
      price,
    };

    onClickAddProduct(obj);
  };

  return (
    <div className="ver-margin-20 u-16 u-7-ms u-5-ls">
      <div className={style + " product__item grid-col"}>
        <div className="u grid center">
          <div className="grid cross-start">
            <img src={img} alt={name} className="product__image" />
          </div>
        </div>
        <div className="grid cross-center between">
          <div>
            <div className="product__name">{name}</div>
            <div className="product__price">
              <Price price={price} />
            </div>
          </div>
          <div>
            <Button onClick={onAddProduct}>
              <span>Купить</span>
              {addedCount && <i className="product__item-counter">{addedCount}</i>}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
